import { dynamicGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import { segmentSchema } from "@redotech/redo-customer-segments-common/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const createDynamicSegment = {
  name: "createDynamicSegment" as const,
  description:
    "Create a dynamic (auto-updating) audience from a set of conditions. Typically followed by createCampaign to target the new segment. Check fetchTeamSegments first to reuse an existing audience instead of duplicating one. Call getSegmentConditionCatalog before composing conditions: dimension ids are not guessable from their display names, and an invented one is rejected.",
  mutates: true,
  input: z.object({ name: z.string(), conditions: segmentSchema }),
  output: dynamicGroupSchema,
};
